import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';


const PreloginToPostloginSignzyConnector = () => {
    const dispatch = useDispatch();
    const history = useHistory();

    useEffect(() => {
     var SignzyData = localStorage.getItem('signzy');
     SignzyData = JSON.parse(SignzyData);
     localStorage.removeItem('signzy');
     history.push({
        pathname: `/kycno`,
        state: SignzyData,
      })
    }, [])

    return (<div>Loading...</div>)
}

export default PreloginToPostloginSignzyConnector